// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import type { ReactElement } from 'react';
import { Server, LifeBuoy } from 'lucide-react';
import { useAuthStore } from '@/store/authStore';

// On-Premise lisans bilgi sayfası (kurulum paketleri — docs/DEPLOYMENT_PACKAGES.md).
//
// Lisans onprem paketindeyken bulutta ürün DB'si YOKTUR; kullanıcı buluttan girerse boş
// ya da yanıltıcı bir ekran yerine bunu görür. HATA sayfası değil BİLGİ sayfasıdır —
// müşteri yanlış bir şey yapmadı; ton sakin, tek odaklı (frontend-design kararı).
// Kurulum adresi GÖSTERİLMEZ: lisans kaydında öyle bir alan yok; olmayan veriyi ekrana
// koymak yerine kullanıcı kendi BT yöneticisine yönlendirilir.
// (OpenDesign'a da soruldu — servis o an 502 verdi [4 deneme, iki ortam]; frontend-design
// önerisiyle ilerlendi: ikon + başlık + iki satır + destek eylemi, mevcut sade sayfa kalıbı.)
export function OnPremiseInfoPage(): ReactElement {
  const logout = useAuthStore((s) => s.logout);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto w-16 h-16 rounded-2xl flex items-center justify-center"
             style={{ background: 'linear-gradient(135deg, #00567f 0%, #003b5c 100%)' }}>
          <Server className="w-8 h-8 text-white" />
        </div>

        <h1 className="mt-5 text-xl font-bold text-foreground">
          Sisteminiz kendi sunucunuzda kurulu
        </h1>
        <p className="mt-2 text-[13.5px] leading-relaxed text-muted-foreground">
          Lisansınız On-Premise paketinde: verileriniz şirketinizin kendi sunucusunda tutulur
          ve bulut üzerinden erişilmez. Uygulamayı kullanmak için şirket içi kurulum adresinizi
          kullanın — adresi bilmiyorsanız BT yöneticinize sorabilirsiniz.
        </p>

        <div className="mt-6 flex items-center justify-center gap-3">
          <a
            href="mailto:destek@elpo.com.tr?subject=On-Premise%20kurulum%20eri%C5%9Fimi"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary text-primary-foreground text-[14px] hover:opacity-90 transition-opacity"
          >
            <LifeBuoy className="w-4 h-4" />
            Destek ile iletişime geç
          </a>
          <button
            type="button"
            onClick={() => logout()}
            className="px-4 py-2 rounded-md border border-border text-[14px] text-foreground hover:bg-accent transition-colors"
          >
            Çıkış yap
          </button>
        </div>
      </div>
    </div>
  );
}
